module.exports = __webpack_public_path__ + "static/Illu_Music-55c459bb53b1fe55525aedd2a6f0aeb8.svg";